import { useQuery } from "@tanstack/react-query";
import { get } from "../services/apiClient";

export interface LeadStats {
  totalViews: number;
  roomClicks: number;
  totalInteractions: number;
  totalLeads: number;
}

export function useLeadStats(businessId: string) {
  return useQuery<LeadStats>({
    queryKey: ["leadStats", businessId],
    queryFn: () => get<LeadStats>(`/leads/stats?businessId=${businessId}`),
    enabled: !!businessId,
  });
}
